import React, { Component, Fragment } from "react";
import axios from "axios";
import { axiosConfig } from "../../../config/utility";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import CreateIcon from "@material-ui/icons/Create";
import { connect } from "react-redux";

import { addSettings } from "../../../actions";
import {
  ListClientRoles,
  ListClientSubRoles,
  setSequenceNo,
  setSequenceNoSub,
  getClientMenuGroups,
  getAttachedMenuItem,
  deleteMenuGroup,
  assignRolesToGroup,
  setDefault,
  unsetDefault,
} from "../../../config/client_role_api_calls";

import $ from "jquery";
import DataTable from "../../../components/Tables/DataTable";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "../../../config/helperClass";
import { THEME_TEXT_COLOR, THEME_COLOR } from "../../../config/config";
import Tooltip from "@material-ui/core/Tooltip";
import dateFormat, { masks } from "dateformat";
import localization from "../../../localization/localization";
import Checkbox from "@material-ui/core/Checkbox";
import UserPermissionHelper from "../../../components/Reseller/UserPermissionHelper";

const auth = new HelperClass();

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

class ClientRoles extends Component {
  constructor() {
    super();
    this.state = {
      listRoleData: [],
      listSubRoleData: [],
      listMenuGroupData: [],
      listAttachMenuData: [],
      selectedMenus: [],
      errorMessaged: "",
      errorMessage: "",
      successMessaged: "",
      successMessage: "",
      title: "",
      name: "",
      logo: "",
      delete_id: "",
      description: "",
      tableLoader: true,
      domain: "",
      step: 1,
      isEditing: null,
      menuSequences: {},
      sequenceNo: "",
      roleId: "",
      errorMessageMatch: "",
      successMessageMatch: "",

      isEditingSub: null,
      menuSequencesSub: {},
      sequenceNoSub: "",
      roleIdSub: "",
      errorMessageMatchSub: "",
      successMessageMatchSub: "",
      assigned_services: [],
      subRoleColumns: [],
      menuGroupColumns: [],
      group_desc: "",
      clientMenuTab: localStorage.getItem("clientMenuTab") || "main_menu",
      selected_group_id: "",
      errorMessageAttach: "",
      successMessageAttach: "",
      attach_group: [],
      groupTitle: "",
      errorMessageDefault: "",
      successMessageDefault: "",
      permissionsState: [],
      permission_add_group: 0,
      permission_edit_group: 0,
      permission_delete_group: 0,
      permission_default_group: 0,
      permission_add_main_menu: 0,
      permission_edit_main_menu: 0,
      permission_add_sub_menu: 0,
      permission_edit_sub_menu: 0,
      rolecolumns: [
        { name: "Title" },
        { name: "Link" },
        { name: "Menu Icon" },
        {
          name: "Menu Sequence",
          options: {
            customBodyRender: (value, tableMeta) => {
              return (
                <div>
                  {this.state.isEditing === tableMeta.rowIndex ? (
                    <div className="flex items-center">
                      <input
                        type="text"
                        value={
                          this.state.menuSequences[tableMeta.rowIndex] ?? value
                        }
                        onChange={(e) =>
                          this.handleMenuSequenceChange(e, tableMeta.rowIndex)
                        }
                        onInput={(e) => {
                          let value = e.target.value.replace(/[^0-9]/g, "");
                          if (value.length === 1) {
                            value = value.replace(/[0]/g, "");
                          }
                          if (
                            value !== "" &&
                            parseInt(value) > 0 &&
                            parseInt(value) <= 99
                          ) {
                            e.target.value = value;
                          } else if (value === "") {
                            e.target.value = "";
                          } else {
                            e.target.value = e.target.previousValue || "";
                          }
                          e.target.previousValue = e.target.value;
                        }}
                        className="w-8 mr-2 p-1 text-center"
                        maxLength="2"
                        disabled={this.state.isSaving}
                      />
                      <Tooltip title="Save" placement="top">
                        <span
                          className="mr-2 text-primary"
                          onClick={() =>
                            this.handleSaveClick(
                              tableMeta.rowIndex,
                              tableMeta.rowData[6],
                            )
                          }
                          style={{
                            cursor: this.state.isSaving ? "default" : "pointer",
                            fontSize: "17px",
                            opacity: this.state.isSaving ? "0.5" : "1",
                            pointerEvents: this.state.isSaving
                              ? "none"
                              : "auto",
                          }}
                        >
                          <em className="icon ni ni-save "></em>
                        </span>
                      </Tooltip>

                      {!this.state.isSaving && (
                        <Tooltip title="Close" placement="top">
                          <span
                            onClick={() => this.handleCancelEdit()}
                            style={{ cursor: "pointer", fontSize: "17px" }}
                          >
                            <em className="icon ni ni-cross"></em>
                          </span>
                        </Tooltip>
                      )}
                    </div>
                  ) : (
                    <div>
                      {value}{" "}
                      <Tooltip title="Edit" placement="top">
                        <span
                          className="mr-1"
                          onClick={() =>
                            this.handleEditClick(tableMeta.rowIndex, value)
                          }
                          style={{
                            cursor: "pointer",
                            fontSize: "13px",
                          }}
                        >
                          <em className="icon ni ni-edit"></em>
                        </span>
                      </Tooltip>
                    </div>
                  )}
                </div>
              );
            },
          },
        },
        {
          name: "status",
          options: {
            customBodyRender: (value, tableMeta) => {
              return <div>{this.roleStatus(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "Default Tab",
          options: {
            customBodyRender: (value, tableMeta) => {
              return <div>{this.roleDefault(value, tableMeta)}</div>;
            },
          },
        },
        { name: "ID", options: { display: false } },
        {
          name: "Groups",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return (
                <div onClick={() => this.attachTo(value, tableMeta)}>
                  <span
                    className="badge badge-outline-secondary"
                    style={{ cursor: "pointer" }}
                  >
                    View
                  </span>
                </div>
              );
            },
          },
        },
        // {
        //   name: "Actions",
        //   options: {
        //     customBodyRender: (value, tableMeta) => {
        //       return (
        //         <div>
        //           <div
        //             className="nk-tb-col nk-tb-col-tools"
        //             style={{ padding: "0px" }}
        //           >
        //             <ul className="nk-tb-actions gx-1">
        //               <li>
        //                 <div className="drodown">
        //                   <a
        //                     href="#"
        //                     className="dropdown-toggle btn btn-icon btn-outline-light"
        //                     data-toggle="dropdown"
        //                   >
        //                     <em className="icon ni ni-more-h"></em>
        //                   </a>
        //                   <div className="dropdown-menu dropdown-menu-right">
        //                     <ul className="link-list-opt no-bdr">
        //                       <li>
        //                         <a
        //                           data-toggle="tooltip"
        //                           data-placement="left"
        //                           onClick={() =>
        //                             this.addMenuHistory(
        //                               "/client_roles/edit_client_role/" +
        //                                 tableMeta.rowData[6]
        //                             )
        //                           }
        //                           title="Edit Email"
        //                           style={{ cursor: "pointer" }}
        //                         >
        //                           <em className="icon ni ni-edit"></em>
        //                           <span>
        //                             {" "}
        //                             {localization.clientsRoles.mainRoleLink}
        //                           </span>
        //                         </a>
        //                       </li>
        //                     </ul>
        //                   </div>
        //                 </div>
        //               </li>
        //             </ul>
        //           </div>
        //         </div>
        //       );
        //     },
        //   },
        // },
        {
          name: "Actions",
          label: "Actions",
          options: {
            customBodyRender: (value, tableMeta) => {
              return (
                <>
                  {this.state.permissionsState &&
                  this.state.permissionsState.length > 0 &&
                  this.state.permission_edit_main_menu === 1 ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        minHeight: 36, // ensures consistent row height
                      }}
                    >
                      {/* Edit Email */}
                      <Tooltip title="Edit Main Menu" placement="top">
                        <a
                          onClick={() =>
                            this.addMenuHistory(
                              "/client_roles/edit_client_role/" +
                                tableMeta.rowData[6],
                            )
                          }
                          style={{ cursor: "pointer" }}
                        >
                          <em
                            className="icon ni ni-edit text-primary"
                            style={{ fontSize: "20px" }}
                          />
                        </a>
                      </Tooltip>
                    </div>
                  ) : (
                    "---"
                  )}
                </>
              );
            },
          },
        },
      ],
      tableData: [],
    };
  }

  async componentDidMount() {
    this.loadPermissions();
    const savedTab = localStorage.getItem("clientMenuTab") || "main_menu";
    this.setState({ tableLoader: true, clientMenuTab: savedTab });

    try {
      if (savedTab === "sub_menu") {
        await this.getClientSubRoles(); // assuming this sets relevant state inside
        this.setState({ tableLoader: false });
      } else if (savedTab === "menu_group") {
        await this.getClientMenuGroups(); // assuming this sets relevant state inside
        this.setState({ tableLoader: false });
      } else {
        const listClientResponse = await ListClientRoles(
          auth.getAccount(),
          auth.getToken(),
        );

        // console.log("ListClientRoles Res: ", listClientResponse.data);

        const { status, message, errors, data } = listClientResponse.data;

        if (
          status === 403 ||
          errors === "authentication missing" ||
          errors === "jwt expired"
        ) {
          auth.logout();
        } else if (status === 404) {
          // Optional: redirect to error page
          this.setState({ tableLoader: false });
        } else if (status === 200 && message === "success") {
          this.setState({
            listRoleData: data,
            tableLoader: false,
          });
        } else {
          this.setState({ tableLoader: false });
        }
      }
    } catch (error) {
      console.error("Error loading client roles:", error);
      this.setState({ tableLoader: false });
    }
  }

  loadPermissions = () => {
    if (!this.props.userRoleItems) return;
    const canEdit = UserPermissionHelper.getAllRoles(
      this.props.userRoleItems,
      "clients",
      "client_menu",
    );
    //console.log("Can Edit Clients:", canEdit[0].edit_client);

    this.setState({
      permissionsState: canEdit,
      permission_add_group: canEdit[0].add_group,
      permission_edit_group: canEdit[0].edit_group,
      permission_delete_group: canEdit[0].delete_group,
      permission_add_main_menu: canEdit[0].add_main_menu,
      permission_edit_main_menu: canEdit[0].edit_main_menu,
      permission_add_sub_menu: canEdit[0].add_sub_menu,
      permission_edit_sub_menu: canEdit[0].edit_sub_menu,
      permission_default_group: canEdit[0].set_default,
    });
    //console.log("Can Edit Clients:", canEdit);
  };

  componentDidUpdate(prevProps) {
    if (prevProps.userRoleItems !== this.props.userRoleItems) {
      this.loadPermissions();
    }
  }

  roleStatus = (value, tableMeta) => {
    let active = tableMeta.rowData[4];
    if (active === 1) {
      return (
        <span className="badge badge-outline-success">
          <em className="icon ni ni-done"></em> Active
        </span>
      );
    } else {
      return (
        <span className="badge badge-outline-primary">
          <em className="icon ni ni-na"></em> In Active
        </span>
      );
    }
  };

  roleDefault = (value, tableMeta) => {
    let active = tableMeta.rowData[5];
    if (active === 1) {
      return (
        <span className="badge badge-outline-success">
          <em className="icon ni ni-done"></em> Yes
        </span>
      );
    } else {
      return (
        <span className="badge badge-outline-primary">
          <em className="icon ni ni-na"></em> No
        </span>
      );
    }
  };

  subRoleStatus = (value, tableMeta) => {
    let active = tableMeta.rowData[5];
    if (active === 1) {
      return (
        <span className="badge badge-outline-success">
          <em className="icon ni ni-done"></em> Active
        </span>
      );
    } else {
      return (
        <span className="badge badge-outline-primary">
          <em className="icon ni ni-na"></em> In Active
        </span>
      );
    }
  };

  subRoleDefault = (value, tableMeta) => {
    let active = tableMeta.rowData[6];
    if (active === 1) {
      return (
        <span className="badge badge-outline-success">
          <em className="icon ni ni-done"></em> Yes
        </span>
      );
    } else {
      return (
        <span className="badge badge-outline-primary">
          <em className="icon ni ni-na"></em> No
        </span>
      );
    }
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  getClientSubRoles = async () => {
    this.setState({
      tableLoader: true,
    });
    const listAgentSubRoleResponce = await ListClientSubRoles(
      auth.getAccount(),
      auth.getToken(),
    );

    // console.log("client sub roles  Res: ", listAgentSubRoleResponce.data);
    if (
      listAgentSubRoleResponce.data.status === 403 ||
      listAgentSubRoleResponce.data.errors === "authentication missing" ||
      listAgentSubRoleResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (listAgentSubRoleResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      listAgentSubRoleResponce.data.status === 200 &&
      listAgentSubRoleResponce.data.message === "success"
    ) {
      this.setState({
        listSubRoleData: listAgentSubRoleResponce.data.data,
        tableLoader: false,
        subRoleColumns: [
          { name: "Title" },
          { name: "Link" },
          { name: "Menu Icon" },
          {
            name: "Menu Sequence",
            options: {
              customBodyRender: (value, tableMeta) => {
                return (
                  <div>
                    {this.state.isEditingSub === tableMeta.rowIndex ? (
                      <div className="flex items-center">
                        <input
                          type="text"
                          value={
                            this.state.menuSequencesSub[tableMeta.rowIndex] ??
                            value
                          }
                          onChange={(e) =>
                            this.handleMenuSequenceChangeSub(
                              e,
                              tableMeta.rowIndex,
                            )
                          }
                          onInput={(e) => {
                            let value = e.target.value.replace(/[^0-9]/g, "");
                            if (value.length === 1) {
                              value = value.replace(/[0]/g, "");
                            }
                            if (
                              value !== "" &&
                              parseInt(value) > 0 &&
                              parseInt(value) <= 99
                            ) {
                              e.target.value = value;
                            } else if (value === "") {
                              e.target.value = "";
                            } else {
                              e.target.value = e.target.previousValue || "";
                            }
                            e.target.previousValue = e.target.value;
                          }}
                          className="w-8 mr-2 p-1 text-center"
                          maxLength="2"
                          disabled={this.state.isSaving}
                          style={{
                            width: "65%",
                          }}
                        />
                        <Tooltip title="Save" placement="top">
                          <span
                            className="mr-2"
                            onClick={() =>
                              this.handleSaveClickSub(
                                tableMeta.rowIndex,
                                tableMeta.rowData[7],
                              )
                            }
                            style={{
                              cursor: this.state.isSaving
                                ? "default"
                                : "pointer",
                              fontSize: "17px",
                              opacity: this.state.isSaving ? "0.5" : "1",
                              pointerEvents: this.state.isSaving
                                ? "none"
                                : "auto",
                            }}
                          >
                            <em className="icon ni ni-save"></em>
                          </span>
                        </Tooltip>

                        {!this.state.isSaving && (
                          <Tooltip title="Close" placement="top">
                            <span
                              onClick={() => this.handleCancelEditSub()}
                              style={{ cursor: "pointer", fontSize: "17px" }}
                            >
                              <em className="icon ni ni-cross"></em>
                            </span>
                          </Tooltip>
                        )}
                      </div>
                    ) : (
                      <div>
                        {value}{" "}
                        <Tooltip title="Edit" placement="top">
                          <span
                            className="mr-1"
                            onClick={() =>
                              this.handleEditClickSub(tableMeta.rowIndex, value)
                            }
                            style={{
                              cursor: "pointer",
                              fontSize: "13px",
                            }}
                          >
                            <em className="icon ni ni-edit"></em>
                          </span>
                        </Tooltip>
                      </div>
                    )}
                  </div>
                );
              },
            },
          },
          { name: "Parent Menu " },
          {
            name: "status",
            options: {
              customBodyRender: (value, tableMeta) => {
                return <div>{this.subRoleStatus(value, tableMeta)}</div>;
              },
            },
          },
          {
            name: "Default Tab",
            options: {
              customBodyRender: (value, tableMeta) => {
                return <div>{this.subRoleDefault(value, tableMeta)}</div>;
              },
            },
          },
          // {
          //   name: "Actions",
          //   options: {
          //     customBodyRender: (value, tableMeta) => {
          //       return (
          //         <div>
          //           <div
          //             className="nk-tb-col nk-tb-col-tools"
          //             style={{ padding: "0px" }}
          //           >
          //             <ul className="nk-tb-actions gx-1">
          //               <li>
          //                 <div className="drodown">
          //                   <a
          //                     href="#"
          //                     className="dropdown-toggle btn btn-icon btn-outline-light"
          //                     data-toggle="dropdown"
          //                   >
          //                     <em className="icon ni ni-more-h"></em>
          //                   </a>
          //                   <div className="dropdown-menu dropdown-menu-right">
          //                     <ul className="link-list-opt no-bdr">
          //                       <li>
          //                         <a
          //                           data-toggle="tooltip"
          //                           data-placement="left"
          //                           onClick={() =>
          //                             this.addMenuHistory(
          //                               "/client_roles/edit_client_subrole/" +
          //                                 tableMeta.rowData[7]
          //                             )
          //                           }
          //                           title="Edit Email"
          //                           style={{ cursor: "pointer" }}
          //                         >
          //                           <em className="icon ni ni-edit"></em>
          //                           <span>
          //                             {" "}
          //                             {
          //                               localization.clientsRoles.subRoleLink
          //                             }{" "}
          //                           </span>
          //                         </a>
          //                       </li>
          //                     </ul>
          //                   </div>
          //                 </div>
          //               </li>
          //             </ul>
          //           </div>
          //         </div>
          //       );
          //     },
          //   },
          // },
          {
            name: "Actions",
            label: "Actions",
            options: {
              customBodyRender: (value, tableMeta) => {
                return (
                  <>
                    {this.state.permissionsState &&
                    this.state.permissionsState.length > 0 &&
                    this.state.permission_edit_sub_menu === 1 ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                          minHeight: 36, // keeps row height uniform
                        }}
                      >
                        {/* Edit Sub Role */}
                        <Tooltip title="Edit Sub Menu" placement="top">
                          <a
                            onClick={() =>
                              this.addMenuHistory(
                                "/client_roles/edit_client_subrole/" +
                                  tableMeta.rowData[7],
                              )
                            }
                            style={{ cursor: "pointer" }}
                          >
                            <em
                              className="icon ni ni-edit text-primary"
                              style={{ fontSize: "20px" }}
                            />
                          </a>
                        </Tooltip>
                      </div>
                    ) : (
                      "---"
                    )}
                  </>
                );
              },
            },
          },
        ],
      });
    } else {
      //window.location.replace("/error");
    }
  };

  handleEditClick = (rowIndex, currentValue) => {
    this.setState({
      isEditing: rowIndex,
      menuSequences: {
        ...this.state.menuSequences,
        [rowIndex]: currentValue,
      },
    });
  };

  handleMenuSequenceChange = (event, rowIndex) => {
    const value = event.target.value;
    this.setState((prevState) => ({
      menuSequences: {
        ...prevState.menuSequences,
        [rowIndex]: value,
      },
    }));
  };

  handleCancelEdit = () => {
    this.setState({
      isEditing: null,
      errorMessage: "",
      successMessage: "",
    });
  };

  handleSaveClick = async (rowIndex, roleId) => {
    const sequenceNo = this.state.menuSequences[rowIndex];

    if (sequenceNo === "" || !sequenceNo) {
      this.setState({
        errorMessage: "Enter the sequence number.",
      });
      setTimeout(() => {
        this.setState({
          errorMessage: "",
        });
      }, 3000);
      return;
    }

    let isMatchFound = this.state.listRoleData.find((role) => {
      return role[3] == sequenceNo && role[6] != roleId;
    });

    if (isMatchFound) {
      this.setState({
        alertModalMessage: (
          <>
            The menu item <b>{isMatchFound[0]}</b> has already used this
            sequence number. Do you want to proceed?
          </>
        ),
        alertModalTitle: "Warning",
        alertModalIcon: "icon ni ni-alert-circle icon-circle-xxl",
        sequenceNo: sequenceNo,
        roleId: roleId,
      });
      window.$("#modalAlertConflict").modal("show");
      return;
    }

    await this.executeSaveSequence(sequenceNo, roleId);
  };

  executeSaveSequence = async (sequenceNo, roleId) => {
    this.setState({ isSaving: true });
    try {
      const listClientResponse = await setSequenceNo(
        auth.getAccount(),
        auth.getToken(),
        sequenceNo,
        roleId,
      );

      if (
        listClientResponse.data.status === 403 ||
        listClientResponse.data.errors === "authentication missing" ||
        listClientResponse.data.errors === "jwt expired"
      ) {
        auth.logout();
        return;
      }

      if (listClientResponse.data.status === 404) {
        this.setState({
          errorMessage: "Menu item not found",
          successMessage: "",
          isSaving: false,
        });
      } else if (
        listClientResponse.data.status === 200 &&
        listClientResponse.data.message === "success"
      ) {
        this.setState(
          {
            errorMessage: "",
            successMessage: "Menu item sequence updated successfully",
            isEditing: null,
            isSaving: false,
          },
          () => {
            setTimeout(() => {
              this.reloadClientRoles();
            }, 500);
          },
        );
      }
    } catch (error) {
      console.error("Error updating sequence:", error);
      this.setState({
        errorMessage: "Failed to update menu sequence",
        successMessage: "",
        isSaving: false,
      });
    }
    setTimeout(() => {
      this.setState({
        errorMessage: "",
        successMessage: "",
      });
    }, 3000);
  };

  updateSequence = async () => {
    this.setState({ isSaving: true });
    try {
      const listClientResponse = await setSequenceNo(
        auth.getAccount(),
        auth.getToken(),
        this.state.sequenceNo,
        this.state.roleId,
      );

      if (
        listClientResponse.data.status === 403 ||
        listClientResponse.data.errors === "authentication missing" ||
        listClientResponse.data.errors === "jwt expired"
      ) {
        auth.logout();
        return;
      }

      if (listClientResponse.data.status === 404) {
        this.setState({
          errorMessageMatch: "Menu item not found",
          successMessageMatch: "",
          isSaving: false,
        });
      } else if (
        listClientResponse.data.status === 200 &&
        listClientResponse.data.message === "success"
      ) {
        this.setState(
          {
            errorMessageMatch: "",
            alertModalTitle: "Success",
            alertModalIcon: "icon ni ni-check-circle icon-circle-xxl",
            successMessageMatch: "Menu item sequence updated successfully",
            isEditing: null,
            isSaving: false,
          },
          () => {
            setTimeout(() => {
              this.reloadClientRoles();
              window.$("#modalAlertConflict").modal("hide");
            }, 3000);
          },
        );
      }
    } catch (error) {
      console.error("Error updating sequence:", error);
      this.setState({
        errorMessageMatch: "Failed to update menu sequence",
        successMessageMatch: "",
        isSaving: false,
      });
    }
    this.removeMessages();
  };

  reloadClientRoles = async () => {
    this.setState({ tableLoader: true });

    try {
      const listClientResponse = await ListClientRoles(
        auth.getAccount(),
        auth.getToken(),
      );

      if (
        listClientResponse.data.status === 403 ||
        listClientResponse.data.errors === "authentication missing" ||
        listClientResponse.data.errors === "jwt expired"
      ) {
        auth.logout();
        return;
      }

      if (
        listClientResponse.data.status === 200 &&
        listClientResponse.data.message === "success"
      ) {
        this.setState({
          listRoleData: listClientResponse.data.data,
          tableLoader: false,
          isEditing: null,
          menuSequences: {},
        });
      } else if (listClientResponse.data.status === 404) {
        this.setState({
          errorMessage: "Failed to load roles",
          tableLoader: false,
        });
      }
    } catch (error) {
      console.error("Error reloading roles:", error);
      this.setState({
        errorMessage: "Failed to reload roles",
        tableLoader: false,
      });
    }
  };

  handleEditClickSub = (rowIndex, currentValue) => {
    this.setState({
      isEditingSub: rowIndex,
      menuSequencesSub: {
        ...this.state.menuSequencesSub,
        [rowIndex]: currentValue,
      },
    });
  };

  handleMenuSequenceChangeSub = (event, rowIndex) => {
    const value = event.target.value;
    this.setState((prevState) => ({
      menuSequencesSub: {
        ...prevState.menuSequencesSub,
        [rowIndex]: value,
      },
    }));
  };

  handleCancelEditSub = () => {
    this.setState({
      isEditingSub: null,
      errorMessage: "",
      successMessage: "",
    });
  };

  handleSaveClickSub = async (rowIndex, roleId) => {
    const sequenceNoSub = this.state.menuSequencesSub[rowIndex];

    if (sequenceNoSub === "" || !sequenceNoSub) {
      this.setState({
        errorMessage: "Enter the sequence number.",
      });
      setTimeout(() => {
        this.setState({
          errorMessage: "",
        });
      }, 3000);
      return;
    }

    let isMatchFound = this.state.listSubRoleData.find((role) => {
      return (
        role[3] == sequenceNoSub &&
        role[4] == this.state.listSubRoleData[rowIndex][4] &&
        role[7] != roleId
      );
    });

    if (isMatchFound) {
      this.setState({
        alertModalMessageSub: (
          <>
            The sub menu item <b>{isMatchFound[0]}</b> has already used this
            sequence number. Do you want to proceed?
          </>
        ),
        alertModalTitleSub: "Warning",
        alertModalIconSub: "icon ni ni-alert-circle icon-circle-xxl",
        sequenceNoSub: sequenceNoSub,
        roleIdSub: roleId,
      });
      window.$("#modalAlertConflictSub").modal("show");
      return;
    }

    await this.executeSaveSequenceSub(sequenceNoSub, roleId);
  };

  executeSaveSequenceSub = async (sequenceNoSub, roleId) => {
    this.setState({ isSaving: true });
    try {
      const listClientResponse = await setSequenceNoSub(
        auth.getAccount(),
        auth.getToken(),
        sequenceNoSub,
        roleId,
      );

      if (
        listClientResponse.data.status === 403 ||
        listClientResponse.data.errors === "authentication missing" ||
        listClientResponse.data.errors === "jwt expired"
      ) {
        auth.logout();
        return;
      }

      if (listClientResponse.data.status === 404) {
        this.setState({
          errorMessage: "Menu item not found",
          successMessage: "",
          isSaving: false,
        });
      } else if (
        listClientResponse.data.status === 200 &&
        listClientResponse.data.message === "success"
      ) {
        this.setState(
          {
            errorMessage: "",
            successMessage: "Menu item sequence updated successfully",
            isEditing: null,
            isSaving: false,
          },
          () => {
            setTimeout(() => {
              this.reloadClientRolesSub();
            }, 500);
          },
        );
      }
    } catch (error) {
      console.error("Error updating sequence:", error);
      this.setState({
        errorMessage: "Failed to update menu sequence",
        successMessage: "",
        isSaving: false,
      });
    }
    setTimeout(() => {
      this.setState({
        errorMessage: "",
        successMessage: "",
      });
    }, 3000);
  };

  updateSequenceSub = async () => {
    this.setState({ isSaving: true });
    try {
      const listClientResponse = await setSequenceNoSub(
        auth.getAccount(),
        auth.getToken(),
        this.state.sequenceNoSub,
        this.state.roleIdSub,
      );

      if (
        listClientResponse.data.status === 403 ||
        listClientResponse.data.errors === "authentication missing" ||
        listClientResponse.data.errors === "jwt expired"
      ) {
        auth.logout();
        return;
      }

      if (listClientResponse.data.status === 404) {
        this.setState({
          errorMessageMatchSub: "Menu item not found",
          successMessageMatchSub: "",
          isSaving: false,
        });
      } else if (
        listClientResponse.data.status === 200 &&
        listClientResponse.data.message === "success"
      ) {
        this.setState(
          {
            errorMessageMatchSub: "",
            alertModalTitleSub: "Success",
            alertModalIconSub: "icon ni ni-check-circle icon-circle-xxl",
            successMessageMatch: "Menu item sequence updated successfully",
            isEditingSub: null,
            isSaving: false,
          },
          () => {
            setTimeout(() => {
              this.reloadClientRolesSub();
              window.$("#modalAlertConflictSub").modal("hide");
            }, 3000);
          },
        );
      }
    } catch (error) {
      console.error("Error updating sequence:", error);
      this.setState({
        errorMessageMatchSub: "Failed to update menu sequence",
        successMessageMatchSub: "",
        isSaving: false,
      });
    }
    this.removeMessages();
  };

  reloadClientRolesSub = async () => {
    this.setState({ tableLoader: true });

    try {
      const listClientResponse = await ListClientSubRoles(
        auth.getAccount(),
        auth.getToken(),
      );

      if (
        listClientResponse.data.status === 403 ||
        listClientResponse.data.errors === "authentication missing" ||
        listClientResponse.data.errors === "jwt expired"
      ) {
        auth.logout();
        return;
      }

      if (
        listClientResponse.data.status === 200 &&
        listClientResponse.data.message === "success"
      ) {
        this.setState({
          listSubRoleData: listClientResponse.data.data,
          tableLoader: false,
          isEditingSub: null,
          menuSequencesSub: {},
        });
      } else if (listClientResponse.data.status === 404) {
        this.setState({
          errorMessage: "Failed to load roles",
          tableLoader: false,
        });
      }
    } catch (error) {
      console.error("Error reloading roles:", error);
      this.setState({
        errorMessage: "Failed to reload roles",
        tableLoader: false,
      });
    }
  };

  removeMessages = () => {
    setTimeout(() => {
      this.setState({
        errorMessageMatch: "",
        successMessageMatch: "",
        errorMessageMatchSub: "",
        successMessageMatchSub: "",
      });
    }, 3000);
  };

  modalHideMatchConflict = () => {
    window.$("#modalAlertConflict").modal("hide");
  };

  modalHideMatchConflictSub = () => {
    window.$("#modalAlertConflictSub").modal("hide");
  };

  activeStatus = (value, tableMeta) => {
    let status = tableMeta.rowData[3];
    if (status === "1") {
      return <span className="badge badge-outline-success">Active</span>;
    } else {
      return <span className="badge badge-outline-danger">Inactive</span>;
    }
  };

  defaultStatus = (value, tableMeta) => {
    let status = tableMeta.rowData[4];
    if (status === "Yes") {
      return <span className="badge badge-outline-success">Yes</span>;
    } else {
      return <span className="badge badge-outline-danger">No</span>;
    }
  };

  getClientMenuGroups = async () => {
    this.setState({
      tableLoader: true,
    });
    const listClientMenuGroups = await getClientMenuGroups(
      auth.getAccount(),
      auth.getToken(),
    );

    // console.log("Client Menu Groups: ", listClientMenuGroups.data);
    if (
      listClientMenuGroups.data.status === 403 ||
      listClientMenuGroups.data.errors === "authentication missing" ||
      listClientMenuGroups.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (listClientMenuGroups.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      listClientMenuGroups.data.status === 200 &&
      listClientMenuGroups.data.message === "success"
    ) {
      this.setState({
        listMenuGroupData: listClientMenuGroups.data.data,
        tableLoader: false,
        menuGroupColumns: [
          { name: "Seq#" },
          { name: "Title" },
          {
            name: "Description",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div onClick={() => this.assignedTo(value, tableMeta)}>
                    <span
                      className="badge badge-outline-secondary"
                      style={{ cursor: "pointer" }}
                    >
                      View
                    </span>
                  </div>
                );
              },
            },
          },
          {
            name: "Status",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.activeStatus(value, tableMeta)}</div>;
              },
            },
          },
          { name: "id", options: { display: "false" } },
          {
            name: "Attached Roles",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.attached_roles(value, tableMeta)}</div>;
              },
            },
          },
          {
            name: "Default",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.defaultStatus(value, tableMeta)}</div>;
              },
            },
          },
          // {
          //   name: "Actions",
          //   options: {
          //     customBodyRender: (value, tableMeta, updateValue) => {
          //       return (
          //         <div>
          //           <div
          //             className="nk-tb-col nk-tb-col-tools"
          //             style={{ padding: "0px" }}
          //           >
          //             <ul className="nk-tb-actions gx-1">
          //               <li>
          //                 <div className="drodown">
          //                   <a
          //                     style={{ cursor: "pointer" }}
          //                     title="Other Actions"
          //                     className="dropdown-toggle btn btn-icon  btn-outline-light"
          //                     data-toggle="dropdown"
          //                   >
          //                     <em className="icon ni ni-more-h"></em>
          //                   </a>
          //                   <div className="dropdown-menu dropdown-menu-right">
          //                     <ul className="link-list-opt no-bdr">
          //                       <li>
          //                         <Tooltip title="Edit Group" placement="top">
          //                           <a
          //                             style={{ cursor: "pointer" }}
          //                             onClick={() =>
          //                               this.addMenuHistory(
          //                                 "/client_roles/editGroup/" +
          //                                   tableMeta.rowData[4]
          //                               )
          //                             }
          //                             disabled={
          //                               this.props.is_msa_signed === "No" ||
          //                               this.props.defaultSettings === "missing"
          //                                 ? true
          //                                 : false
          //                             }
          //                           >
          //                             <em className="icon ni ni-edit"></em>
          //                             <span> Edit </span>
          //                           </a>
          //                         </Tooltip>
          //                       </li>
          //                       <li>
          //                         <Tooltip title="Delete Group" placement="top">
          //                           <a
          //                             style={{ cursor: "pointer" }}
          //                             onClick={() =>
          //                               this.handleDeleteGroup(value, tableMeta)
          //                             }
          //                             disabled={
          //                               this.props.is_msa_signed === "No" ||
          //                               this.props.defaultSettings === "missing"
          //                                 ? true
          //                                 : false
          //                             }
          //                           >
          //                             <em className="icon ni ni-trash"></em>
          //                             <span> Delete </span>
          //                           </a>
          //                         </Tooltip>
          //                       </li>
          //                     </ul>
          //                   </div>
          //                 </div>
          //               </li>
          //             </ul>
          //           </div>
          //         </div>
          //       );
          //     },
          //   },
          // },
          {
            name: "Actions",
            label: "Actions",
            options: {
              customBodyRender: (value, tableMeta) => {
                const isDisabledGlobally =
                  this.props.is_msa_signed === "No" ||
                  this.props.defaultSettings === "missing";

                const id = tableMeta.rowData[5]; // service type id
                const isDefault = tableMeta.rowData[4] === "Yes";

                return (
                  <>
                    {this.state.permissionsState &&
                    this.state.permissionsState.length > 0 &&
                    (this.state.permission_edit_group === 1 ||
                      this.state.permission_default_group === 1 ||
                      this.state.permission_delete_group === 1) ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                          minHeight: 36, // ensures consistent row height
                        }}
                      >
                        {/* Edit Group */}
                        {this.state.permissionsState &&
                        this.state.permissionsState.length > 0 &&
                        this.state.permission_edit_group === 1 ? (
                          <Tooltip title="Edit Group" placement="top">
                            <a
                              onClick={() =>
                                this.addMenuHistory(
                                  "/client_roles/editGroup/" +
                                    tableMeta.rowData[5],
                                )
                              }
                              style={{
                                cursor: isDisabledGlobally
                                  ? "not-allowed"
                                  : "pointer",
                                pointerEvents: isDisabledGlobally
                                  ? "none"
                                  : "auto",
                              }}
                              disabled={isDisabledGlobally}
                            >
                              <em
                                className="icon ni ni-edit text-primary"
                                style={{
                                  fontSize: "20px",
                                  opacity: isDisabledGlobally ? 0.3 : 1,
                                }}
                              />
                            </a>
                          </Tooltip>
                        ) : null}

                        {/* Default Group */}
                        {this.state.permissionsState &&
                        this.state.permissionsState.length > 0 &&
                        this.state.permission_default_group === 1 ? (
                          <Tooltip
                            title={
                              isDefault ? "Unset Default" : "Set as Default"
                            }
                            placement="top"
                          >
                            <span
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                              }}
                              onClick={() => {
                                isDefault
                                  ? this.defaultAlertNew(id)
                                  : this.defaultAlert(id);
                              }}
                            >
                              <em
                                className={`icon ni ${
                                  isDefault ? "ni-star-fill" : "ni-star"
                                } text-secondary`}
                                style={{
                                  fontSize: 20,
                                  paddingLeft: 5,
                                  borderLeft:
                                    this.state.permission_edit_group === 1
                                      ? "1px solid rgb(0 0 0 / 87%)"
                                      : "none",
                                }}
                              />
                            </span>
                          </Tooltip>
                        ) : null}

                        {/* Delete Group */}
                        {this.state.permissionsState &&
                        this.state.permissionsState.length > 0 &&
                        this.state.permission_delete_group === 1 ? (
                          <Tooltip title="Delete Group" placement="top">
                            <a
                              onClick={() =>
                                this.handleDeleteGroup(value, tableMeta)
                              }
                              style={{
                                cursor: isDisabledGlobally
                                  ? "not-allowed"
                                  : "pointer",
                                pointerEvents: isDisabledGlobally
                                  ? "none"
                                  : "auto",
                              }}
                              disabled={isDisabledGlobally}
                            >
                              <em
                                className="icon ni ni-trash text-danger"
                                style={{
                                  fontSize: 20,
                                  paddingLeft: 5,
                                  borderLeft:
                                    this.state.permission_edit_group === 1 ||
                                    this.state.permission_default_group === 1
                                      ? "1px solid rgb(0 0 0 / 87%)"
                                      : "none",
                                  opacity: isDisabledGlobally ? 0.3 : 1,
                                }}
                              />
                            </a>
                          </Tooltip>
                        ) : null}
                      </div>
                    ) : (
                      "---"
                    )}
                  </>
                );
              },
            },
          },
        ],
      });
    } else {
      //window.location.replace("/error");
    }
  };

  assignedTo = (value, tableMeta) => {
    let group_desc = tableMeta.rowData[2];
    this.setState(
      {
        group_desc: group_desc,
      },
      () => {
        window.$("#modalGroupDescription").modal("show");
      },
    );
  };

  attachTo = (value, tableMeta) => {
    let attach_group = tableMeta.rowData[7];
    this.setState(
      {
        attach_group: attach_group,
      },
      () => {
        window.$("#modalAttachGroups").modal("show");
      },
    );
  };

  attached_roles = (value, tableMeta) => {
    const groupStatus = tableMeta.rowData[3];
    return (
      <span
        className="badge badge-outline-secondary"
        onClick={() => {
          if (groupStatus === "1") {
            this.getAttachedMenuItem(value, tableMeta);
          } else {
            this.setState({ groupTitle: tableMeta.rowData[1] }, () => {
              window.$("#modalGroupInactiveWarning").modal("show");
            });
          }
        }}
        style={{ cursor: "pointer" }}
      >
        Attached Roles
      </span>
    );
  };

  getAttachedMenuItem = async (value, tableMeta) => {
    let group_id = tableMeta.rowData[5];
    let groupTitle = tableMeta.rowData[1];
    this.setState({
      selected_group_id: group_id,
      groupTitle: groupTitle,
    });
    const listClientMenuGroups = await getAttachedMenuItem(
      auth.getAccount(),
      auth.getToken(),
      group_id,
    );
    // console.log("Attach items: ", listClientMenuGroups.data);
    if (
      listClientMenuGroups.data.status === 403 ||
      listClientMenuGroups.data.errors === "authentication missing" ||
      listClientMenuGroups.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (listClientMenuGroups.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      listClientMenuGroups.data.status === 200 &&
      listClientMenuGroups.data.message === "success"
    ) {
      this.setState({
        listAttachMenuData: listClientMenuGroups.data.data, // all roles with attached = true/false
        selectedMenus: listClientMenuGroups.data.data
          .filter((item) => item.attached)
          .map((item) => item.id),
      });
    } else {
      //window.location.replace("/error");
    }
    window.$("#modalClientMenuAttach").modal("show");
  };

  toggleMenu = (id) => {
    this.setState((prevState) => {
      const selected = prevState.selectedMenus || [];
      return {
        selectedMenus: selected.includes(id)
          ? selected.filter((item) => item !== id)
          : [...selected, id],
      };
    });
  };

  toggleSelectAll = () => {
    const { listAttachMenuData, selectedMenus } = this.state;
    const allIds = listAttachMenuData.map((item) => item.id);

    const isAllSelected = selectedMenus?.length === allIds.length;

    this.setState({
      selectedMenus: isAllSelected ? [] : allIds,
    });
  };

  saveAttachedMenus = async () => {
    const response = await assignRolesToGroup(
      auth.getAccount(),
      auth.getToken(),
      this.state.selected_group_id,
      this.state.selectedMenus,
    );

    // console.log("Assign response: ", response.data);

    if (
      response.data.status === 403 ||
      response.data.errors === "authentication missing" ||
      response.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (response.data.status === 404) {
      this.setState({
        errorMessageAttach:
          "There is some error while assigning menu to the group.",
        successMessageAttach: "",
        disabled: false,
      });
      setTimeout(() => {
        this.setState({ errorMessageAttach: "" });
      }, 3000);
    } else if (
      response.data.status === 200 &&
      response.data.message === "success"
    ) {
      this.setState({
        errorMessageAttach: "",
        successMessageAttach: "Menu successfully assigned to the group.",
        disabled: false,
      });

      setTimeout(() => {
        this.setState({
          errorMessageAttach: "",
          successMessageAttach: "",
          errorMessageWarning: "",
        });
        window.$("#modalClientMenuAttach").modal("hide");
      }, 3000);
    } else {
      this.setState({
        errorMessageAttach:
          "There is some error while assigning menu to group.",
        successMessageAttach: "",
        disabled: false,
      });
      setTimeout(() => {
        this.setState({ errorMessageAttach: "", successMessageAttach: "" });
      }, 3000);
    }
  };

  handleDeleteGroup = (value, tableMeta) => {
    let selected_group_id = tableMeta.rowData[5];
    this.setState({
      selected_group_id: selected_group_id,
      successMessageAttach: "",
      errorMessageAttach: "",
    });
    window.$("#modalDeleteGroup").modal("show");
  };

  modalHideDelGroup = () => {
    window.$("#modalDeleteGroup").modal("hide");
  };

  deleteMenuGroup = async () => {
    this.setState({
      disabled: true,
      errorMessageAttach: "",
      successMessageAttach: "",
    });
    const servicesResponse = await deleteMenuGroup(
      auth.getAccount(),
      auth.getToken(),
      this.state.selected_group_id,
    );

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "not_found"
    ) {
      this.setState({
        errorMessageAttach: "Error group not found.",
        successMessageAttach: "",
        disabled: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      this.setState(
        {
          successMessageAttach: "Group deleted successfully.",
          errorMessageAttach: "",
          disabled: false,
        },
        () => {
          setTimeout(() => {
            window.$("#modalDeleteGroup").modal("hide");
            this.getClientMenuGroups();
            this.setState({ successMessageAttach: "", errorMessageAttach: "" });
          }, 3000);
        },
      );
    }
  };

  defaultAlert = (value) => {
    let id = value;
    this.setState({
      selected_group_id: id,
    });
    window.$("#modalDefaultAlert").modal("show");
  };

  modalHideDefault = () => {
    window.$("#modalDefaultAlert").modal("hide");
  };

  setDefault = async () => {
    let group_id = this.state.selected_group_id;
    this.setState({ isProcessing: true });
    const serviceResponce = await setDefault(
      auth.getAccount(),
      auth.getToken(),
      group_id,
    );

    // console.log("defaultServiceResponse: ", serviceResponce.data);

    if (
      serviceResponce.data.status === 403 ||
      serviceResponce.data.errors === "authentication missing" ||
      serviceResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      serviceResponce.data.status === 404 &&
      serviceResponce.data.message === "fail" &&
      serviceResponce.data.note !== ""
    ) {
      // window.location.replace("/error");
      this.setState({
        errorMessageDefault: serviceResponce.data.note,
        successMessageDefault: "",
        disabled: false,
        isProcessing: false,
      });
    } else if (
      serviceResponce.data.status === 200 &&
      serviceResponce.data.message === "success"
    ) {
      this.setState(
        {
          errorMessageDefault: "",
          successMessageDefault: "Group set as default successfully.",
          disabled: false,
          isProcessing: false,
        },
        () => {
          setTimeout(() => {
            window.$("#modalDefaultAlert").modal("hide");
            this.getClientMenuGroups();
            this.setState({
              successMessageDefault: "",
              errorMessageDefault: "",
              isProcessing: false,
              disabled: false,
            });
          }, 3000);
        },
      );
    } else {
      this.setState({
        errorMessageDefault: serviceResponce.data.message,
        successMessageDefault: "",
        disabled: false,
        isProcessing: false,
      });
      //window.location.replace("/error");
    }
  };

  defaultAlertNew = (value) => {
    let id = value;
    this.setState({
      selected_group_id: id,
    });
    window.$("#modalDefaultAlertNew").modal("show");
  };

  modalHideDefaultNew = () => {
    window.$("#modalDefaultAlertNew").modal("hide");
  };

  unsetDefault = async () => {
    let group_id = this.state.selected_group_id;
    this.setState({ isProcessing: true });
    const serviceResponce = await unsetDefault(
      auth.getAccount(),
      auth.getToken(),
      group_id,
    );

    // console.log("defaultServiceResponse: ", serviceResponce.data);

    if (
      serviceResponce.data.status === 403 ||
      serviceResponce.data.errors === "authentication missing" ||
      serviceResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      serviceResponce.data.status === 404 &&
      serviceResponce.data.message === "fail" &&
      serviceResponce.data.note !== ""
    ) {
      // window.location.replace("/error");
      this.setState({
        errorMessageDefault: serviceResponce.data.note,
        successMessageDefault: "",
        disabled: false,
        isProcessing: false,
      });
    } else if (
      serviceResponce.data.status === 200 &&
      serviceResponce.data.message === "success"
    ) {
      this.setState(
        {
          errorMessageDefault: "",
          successMessageDefault: "Default status removed successfully.",
          disabled: false,
          isProcessing: false,
        },
        () => {
          setTimeout(() => {
            window.$("#modalDefaultAlertNew").modal("hide");
            this.getClientMenuGroups();
            this.setState({
              successMessageDefault: "",
              errorMessageDefault: "",
              isProcessing: false,
              disabled: false,
            });
          }, 3000);
        },
      );
    } else {
      this.setState({
        errorMessageDefault: serviceResponce.data.message,
        successMessageDefault: "",
        disabled: false,
        isProcessing: false,
      });
      //window.location.replace("/error");
    }
  };

  render() {
    return (
      <div className="nk-content ">
        <div className="container-fluid">
          {this.props.defaultSettings === "missing" ? <SettingsError /> : null}
          {/* MSA WARNING  START*/}
          {this.props.is_msa_signed === "No" ? <MsaWarning /> : null}
          {/* MODAL EDIT PROFILE START */}
          {/* MSA WARNING END */}
          <div className="nk-block-head nk-block-head-sm">
            <div className="nk-block-between">
              <div className="nk-block-head-content">
                <h3 className="nk-block-title page-title">
                  <PageTitle
                    name={localization.clientsRoles.heading}
                    icon="icon ni ni-grid-alt"
                  />
                </h3>
              </div>
              <div className="nk-block-head-content" id="HeadContent">
                <div className="toggle-wrap nk-block-tools-toggle">
                  <a
                    href="#"
                    className="btn btn-icon btn-trigger toggle-expand mr-n1"
                    data-target="pageMenu"
                  >
                    {/*<em className="icon ni ni-more-v"></em>*/}
                  </a>
                  <div
                    className="toggle-expand-content"
                    data-content="pageMenu"
                  >
                    <ul className="nk-block-tools g-3">
                      {this.state.permissionsState &&
                      this.state.permissionsState.length > 0 &&
                      this.state.permission_add_group === 1 ? (
                        <li className="nk-block-tools-opt">
                          <button
                            type="button"
                            style={{ cursor: "pointer", color: "#fff" }}
                            onClick={() =>
                              this.addMenuHistory("/client_roles/addGroup")
                            }
                            className="btn btn-primary"
                          >
                            <em className="icon ni ni-plus-round"></em>
                            &nbsp;Add New Group
                          </button>
                        </li>
                      ) : null}
                      {this.state.permissionsState &&
                      this.state.permissionsState.length > 0 &&
                      (this.state.permission_add_main_menu === 1 ||
                        this.state.permission_add_sub_menu === 1) ? (
                        <li className="nk-block-tools-opt">
                          <div className="dropdown">
                            <a
                              href="#"
                              className="btn btn-large btn-primary"
                              data-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <span>
                                {localization.clientsRoles.addNewButton}
                              </span>
                              <em className="icon ni ni-chevron-down"></em>
                            </a>
                            <div className="dropdown-menu dropdown-menu-right dropdown-menu-auto mt-1">
                              <ul className="link-list-plain">
                                {this.state.permissionsState &&
                                this.state.permissionsState.length > 0 &&
                                this.state.permission_add_main_menu === 1 ? (
                                  <li>
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        localStorage.setItem(
                                          "clientMenuTab",
                                          "main_menu",
                                        );
                                        this.addMenuHistory(
                                          "/client_roles/add_client_role/",
                                        );
                                      }}
                                    >
                                      <span>
                                        <em className="icon ni ni-plus"></em>{" "}
                                        {
                                          localization.clientsRoles
                                            .addNewButtonLink1
                                        }
                                      </span>
                                    </a>
                                  </li>
                                ) : null}
                                {this.state.permissionsState &&
                                this.state.permissionsState.length > 0 &&
                                this.state.permission_add_sub_menu === 1 ? (
                                  <li>
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        localStorage.setItem(
                                          "clientMenuTab",
                                          "sub_menu",
                                        );
                                        this.addMenuHistory(
                                          "/client_roles/add_client_subrole/",
                                        );
                                      }}
                                    >
                                      <span>
                                        <em className="icon ni ni-plus"></em>{" "}
                                        {
                                          localization.clientsRoles
                                            .addNewButtonLink2
                                        }
                                      </span>
                                    </a>
                                  </li>
                                ) : null}
                              </ul>
                            </div>
                          </div>
                        </li>
                      ) : null}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="nk-block">
            {/* Table 5th Col Start */}
            <div className="row g-gs">
              <div className="col-xxl-12">
                {this.state.errorMessage !== "" ? (
                  <div className="example-alert mb-2">
                    <div className="alert alert-pro alert-danger">
                      <div className="alert-text">
                        <h4>Error</h4>
                        <p>{this.state.errorMessage}</p>
                      </div>
                    </div>
                  </div>
                ) : null}
                {this.state.successMessage !== "" ? (
                  <div className="example-alert mb-2">
                    <div className="alert alert-pro alert-success">
                      <div className="alert-text">
                        <h4>Success</h4>
                        <p>{this.state.successMessage}</p>
                      </div>
                    </div>
                  </div>
                ) : null}
                <div className="nk-block nk-block-lg">
                  <div className="row g-gs">
                    <div className="col-xxl-12">
                      <div className="nk-block nk-block-lg">
                        <div className="card card-bordered">
                          <div className="card-inner">
                            <ul className="nav nav-tabs">
                              <li className="nav-item">
                                <a
                                  className={`nav-link ${
                                    this.state.clientMenuTab === "main_menu"
                                      ? "active"
                                      : ""
                                  }`}
                                  data-toggle="tab"
                                  href="#adminEmails"
                                  onClick={() => {
                                    this.setState({
                                      clientMenuTab: "main_menu",
                                    });
                                    localStorage.setItem(
                                      "clientMenuTab",
                                      "main_menu",
                                    );
                                    this.componentDidMount(); // or call specific refresh logic
                                  }}
                                >
                                  <em className="icon ni ni-grid-alt"></em>
                                  <span>
                                    {
                                      localization.clientsRoles.mainRolesTab
                                    }{" "}
                                  </span>
                                </a>
                              </li>
                              <li className="nav-item">
                                <a
                                  className={`nav-link ${
                                    this.state.clientMenuTab === "sub_menu"
                                      ? "active"
                                      : ""
                                  }`}
                                  data-toggle="tab"
                                  href="#agentEmails"
                                  onClick={() => {
                                    this.setState({
                                      clientMenuTab: "sub_menu",
                                    });
                                    localStorage.setItem(
                                      "clientMenuTab",
                                      "sub_menu",
                                    );
                                    this.getClientSubRoles();
                                  }}
                                >
                                  <em className="icon ni ni-grid-alt"></em>
                                  <span>
                                    {localization.clientsRoles.subRoleTab}
                                  </span>
                                </a>
                              </li>
                              <li className="nav-item">
                                <a
                                  className={`nav-link ${
                                    this.state.clientMenuTab === "menu_group"
                                      ? "active"
                                      : ""
                                  }`}
                                  data-toggle="tab"
                                  href="#agentEmails"
                                  onClick={() => {
                                    this.setState({
                                      clientMenuTab: "menu_group",
                                    });
                                    localStorage.setItem(
                                      "clientMenuTab",
                                      "menu_group",
                                    );
                                    this.getClientMenuGroups();
                                  }}
                                >
                                  <em className="icon ni ni-link-group"></em>
                                  <span>Menu Groups</span>
                                </a>
                              </li>
                            </ul>
                            <div className="tab-content">
                              <div
                                className={`tab-pane ${
                                  this.state.clientMenuTab === "main_menu"
                                    ? "active"
                                    : ""
                                }`}
                                id="adminEmails"
                              >
                                {this.state.tableLoader === true ? (
                                  tableLoader()
                                ) : (
                                  <DataTable
                                    columns={this.state.rolecolumns}
                                    tableData={this.state.listRoleData}
                                    title={
                                      localization.clientsRoles.mainRolesSub
                                    }
                                  />
                                )}
                              </div>
                              <div
                                className={`tab-pane ${
                                  this.state.clientMenuTab === "sub_menu"
                                    ? "active"
                                    : ""
                                }`}
                                id="agentEmails"
                              >
                                {this.state.tableLoader === true ? (
                                  tableLoader()
                                ) : (
                                  <DataTable
                                    columns={this.state.subRoleColumns}
                                    tableData={this.state.listSubRoleData}
                                    title={
                                      localization.clientsRoles.subRoleTabSub
                                    }
                                  />
                                )}
                              </div>
                              <div
                                className={`tab-pane ${
                                  this.state.clientMenuTab === "menu_group"
                                    ? "active"
                                    : ""
                                }`}
                                id="agentEmails"
                              >
                                {this.state.tableLoader === true ? (
                                  tableLoader()
                                ) : (
                                  <DataTable
                                    columns={this.state.menuGroupColumns}
                                    tableData={this.state.listMenuGroupData}
                                    title="Menu Groups"
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Table 5th Col End */}
            {/* ROLE MATCH ALERT START */}
            <div className="modal fade" tabIndex="-1" id="modalAlertConflict">
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <a
                    style={{ cursor: "pointer" }}
                    className="close"
                    onClick={() => {
                      this.modalHideMatchConflict();
                    }}
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                  <div className="modal-body modal-body-lg text-center">
                    <div className="nk-modal">
                      <em
                        className={this.state.alertModalIcon}
                        style={{
                          fontSize: "6rem",
                        }}
                      ></em>

                      <h4 className="nk-modal-title">
                        {this.state.alertModalTitle}
                      </h4>

                      <div className="nk-modal-text">
                        <p>{this.state.alertModalMessage}</p>
                        {this.state.errorMessageMatch !== "" ? (
                          <div
                            className="example-alert"
                            style={{ marginBottom: "15px" }}
                          >
                            <div className="alert alert-pro alert-danger">
                              <div className="alert-text">
                                <h4>Error</h4>
                                <p>{this.state.errorMessageMatch}</p>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        {this.state.successMessageMatch !== "" ? (
                          <div
                            className="example-alert"
                            style={{ marginBottom: "15px" }}
                          >
                            <div className="alert alert-pro alert-success">
                              <div className="alert-text">
                                <h4>Success</h4>
                                <p>{this.state.successMessageMatch}</p>
                              </div>
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <div className="nk-modal-action">
                        <a
                          style={{ cursor: "pointer" }}
                          className="btn btn-lg btn-mw btn-danger"
                          onClick={() => {
                            this.modalHideMatchConflict();
                          }}
                        >
                          CANCEL
                        </a>
                        {"  "}
                        <a
                          style={{
                            cursor: "pointer",
                          }}
                          className="btn btn-lg btn-mw btn-primary"
                          onClick={() => {
                            this.updateSequence();
                          }}
                          disabled={this.state.isSaving}
                        >
                          {this.state.isSaving ? (
                            <span>UPDATING...</span>
                          ) : (
                            <span>UPDATE</span>
                          )}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* ROLE MATCH ALERT END */}
            {/* SUB ROLE MATCH ALERT START */}
            <div
              className="modal fade"
              tabIndex="-1"
              id="modalAlertConflictSub"
            >
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <a
                    style={{ cursor: "pointer" }}
                    className="close"
                    onClick={() => {
                      this.modalHideMatchConflictSub();
                    }}
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                  <div className="modal-body modal-body-lg text-center">
                    <div className="nk-modal">
                      <em
                        className={this.state.alertModalIconSub}
                        style={{
                          fontSize: "6rem",
                        }}
                      ></em>

                      <h4 className="nk-modal-title">
                        {this.state.alertModalTitleSub}
                      </h4>

                      <div className="nk-modal-text">
                        <p>{this.state.alertModalMessageSub}</p>
                        {this.state.errorMessageMatch !== "" ? (
                          <div
                            className="example-alert"
                            style={{ marginBottom: "15px" }}
                          >
                            <div className="alert alert-pro alert-danger">
                              <div className="alert-text">
                                <h4>Error</h4>
                                <p>{this.state.errorMessageMatch}</p>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        {this.state.successMessageMatch !== "" ? (
                          <div
                            className="example-alert"
                            style={{ marginBottom: "15px" }}
                          >
                            <div className="alert alert-pro alert-success">
                              <div className="alert-text">
                                <h4>Success</h4>
                                <p>{this.state.successMessageMatch}</p>
                              </div>
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <div className="nk-modal-action">
                        <a
                          style={{ cursor: "pointer" }}
                          className="btn btn-lg btn-mw btn-danger"
                          onClick={() => {
                            this.modalHideMatchConflictSub();
                          }}
                        >
                          CANCEL
                        </a>
                        {"  "}
                        <a
                          style={{
                            cursor: "pointer",
                          }}
                          className="btn btn-lg btn-mw btn-primary"
                          onClick={() => {
                            this.updateSequenceSub();
                          }}
                          disabled={this.state.isSaving}
                        >
                          {this.state.isSaving ? (
                            <span>UPDATING...</span>
                          ) : (
                            <span>UPDATE</span>
                          )}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* SUB ROLE MATCH ALERT END */}
            {/* Modal Group Desc */}
            <div
              className="modal fade"
              tabIndex="-1"
              id="modalGroupDescription"
            >
              <div
                className="modal-dialog modal-xl modal-dialog-top"
                role="document"
              >
                <div className="modal-content">
                  <a
                    href="#"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                  <div className="modal-header">
                    <h5 className="modal-title">Group Description</h5>
                  </div>
                  <div className="modal-body">
                    <p className="text-dark">
                      {this.state.group_desc && this.state.group_desc !== ""
                        ? this.state.group_desc
                        : "No Description"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* Modal Group Desc */}
            {/* Client Menu Assignment Modal */}
            <div
              className="modal fade"
              tabIndex="-1"
              id="modalClientMenuAttach"
            >
              <div
                className="modal-dialog modal-lg modal-dialog-top"
                role="document"
                style={{ maxWidth: "600px" }}
              >
                <div className="modal-content">
                  <div
                    className="modal-header"
                    style={{ paddingTop: "10px", paddingBottom: "10px" }}
                  >
                    <div
                      className="modal-title"
                      style={{ textAlign: "center", fontSize: "18px" }}
                    >
                      <strong>
                        <em
                          className="icon ni ni-grid-alt"
                          style={{ marginRight: "5px" }}
                        ></em>
                        Attach Roles{" "}
                        <sup>
                          <small className="text-soft">
                            {this.state.groupTitle}
                          </small>
                        </sup>
                      </strong>
                    </div>
                    <a
                      href="#"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                  </div>

                  <div className="modal-body text-left">
                    <div className="nk-modal">
                      {this.state.errorMessageAttach !== "" && (
                        <div className="example-alert example-alert-revoke">
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h4>Error</h4>
                              <p>{this.state.errorMessageAttach}</p>
                            </div>
                          </div>
                        </div>
                      )}

                      {this.state.successMessageAttach !== "" && (
                        <div className="example-alert example-alert-revoke">
                          <div className="alert alert-pro alert-success">
                            <div className="alert-text">
                              <h4>Success</h4>
                              <p>{this.state.successMessageAttach}</p>
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="nk-modal-text mt-2">
                        {this.state.menuLoading ? (
                          tableLoader()
                        ) : (
                          <div className="card card-bordered card-preview">
                            <table className="table table-sm">
                              <thead className="tb-odr-head">
                                <tr className="tb-odr-item">
                                  <th
                                    width="15%"
                                    style={{
                                      borderRight: "1px solid #dbdfea",
                                      fontWeight: 600,
                                      textTransform: "uppercase",
                                      textAlign: "center",
                                      verticalAlign: "middle",
                                    }}
                                  >
                                    <Checkbox
                                      checked={
                                        this.state.listAttachMenuData?.length >
                                          0 &&
                                        this.state.selectedMenus?.length ===
                                          this.state.listAttachMenuData.length
                                      }
                                      indeterminate={false}
                                      onChange={this.toggleSelectAll}
                                      color="primary"
                                      size="small"
                                    />
                                  </th>
                                  <th
                                    width="85%"
                                    style={{
                                      fontWeight: 600,
                                      textTransform: "uppercase",
                                      textAlign: "left",
                                      paddingLeft: "20px",
                                      verticalAlign: "middle",
                                    }}
                                  >
                                    Menu Title
                                  </th>
                                </tr>
                              </thead>

                              <tbody className="tb-odr-body">
                                {this.state.listAttachMenuData?.map(
                                  (menuItem, index) => (
                                    <tr key={`menu${index}`}>
                                      <td
                                        style={{
                                          borderRight: "1px solid #dbdfea",
                                          verticalAlign: "middle",
                                          textAlign: "center",
                                        }}
                                      >
                                        <Checkbox
                                          checked={
                                            this.state.selectedMenus?.includes(
                                              menuItem.id,
                                            ) || false
                                          }
                                          onChange={() =>
                                            this.toggleMenu(menuItem.id)
                                          }
                                          color="primary"
                                          size="small"
                                        />
                                      </td>
                                      <td
                                        style={{
                                          verticalAlign: "middle",
                                          paddingLeft: "20px",
                                          fontWeight: 500,
                                        }}
                                      >
                                        {menuItem.title}
                                      </td>
                                    </tr>
                                  ),
                                )}
                              </tbody>
                            </table>
                          </div>
                        )}

                        <div className="nk-modal-action text-right mt-3">
                          <a
                            href="#"
                            className="btn btn-md btn-primary"
                            onClick={this.saveAttachedMenus}
                            disabled={this.state.disableMenuSave}
                          >
                            Save Changes
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* END Client Menu Assignment Modal */}
            {/* START Agent DELETE MODAL  */}
            <div className="modal fade" tabIndex="-1" id="modalDeleteGroup">
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <a
                    style={{ cursor: "pointer" }}
                    className="close"
                    onClick={() => {
                      this.modalHideDelGroup();
                    }}
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                  <div className="modal-body modal-body-lg text-center">
                    <div className="nk-modal">
                      <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-trash bg-success"></em>

                      <h4 className="nk-modal-title">
                        Do you want to delete the group?
                      </h4>

                      <div className="nk-modal-text">
                        {this.state.errorMessageAttach !== "" ? (
                          <div
                            className="example-alert"
                            style={{ marginBottom: "15px" }}
                          >
                            <div className="alert alert-pro alert-danger">
                              <div className="alert-text">
                                <h4>Error</h4>
                                <p>{this.state.errorMessageAttach}</p>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        {this.state.successMessageAttach !== "" ? (
                          <div
                            className="example-alert"
                            style={{ marginBottom: "15px" }}
                          >
                            <div className="alert alert-pro alert-success">
                              <div className="alert-text">
                                <h4>Success</h4>
                                <p>{this.state.successMessageAttach}</p>
                              </div>
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <div className="nk-modal-action">
                        <a
                          style={{ cursor: "pointer" }}
                          className="btn btn-lg btn-mw btn-primary"
                          onClick={() => {
                            this.modalHideDelGroup();
                          }}
                        >
                          CANCEL
                        </a>
                        {"  "}
                        <button
                          style={{ cursor: "pointer" }}
                          className="btn btn-lg btn-mw btn-danger"
                          onClick={() => {
                            this.deleteMenuGroup();
                          }}
                          disabled={
                            this.state.disabled || this.state.isProcessing
                          } // disable button when processing
                        >
                          {this.state.isProcessing ? (
                            <span>DELETING...</span>
                          ) : (
                            <span>DELETE</span>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* END Client DELETE MODAL  */}
            {/* START Inactive Group Warning MODAL  */}
            <div
              className="modal fade"
              tabIndex="-1"
              id="modalGroupInactiveWarning"
            >
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <a
                    style={{ cursor: "pointer" }}
                    className="close"
                    onClick={() => {
                      window.$("#modalGroupInactiveWarning").modal("hide");
                    }}
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                  <div className="modal-body modal-body-lg text-center">
                    <div className="nk-modal">
                      <em
                        className="nk-modal-icon ni ni-alert-circle text-warning"
                        style={{ fontSize: "48px" }}
                      ></em>

                      <h4 className="nk-modal-title">Inactive Menu Group</h4>

                      <div className="nk-modal-text mt-2">
                        <p>
                          The group <strong>{this.state.groupTitle}</strong> is
                          currently <strong>inactive</strong>.
                        </p>
                        <p>
                          You must activate the group to view the roles attached
                          to it or to assign new menu roles.
                        </p>
                      </div>

                      <div className="nk-modal-action mt-4">
                        <button
                          type="button"
                          className="btn btn-lg btn-mw btn-primary"
                          onClick={() => {
                            window
                              .$("#modalGroupInactiveWarning")
                              .modal("hide");
                          }}
                        >
                          OKAY
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* END Inactive Group Warning MODAL  */}
            {/* Modal Group Desc */}
            <div className="modal fade" tabIndex="-1" id="modalAttachGroups">
              <div
                className="modal-dialog modal-md modal-dialog-top"
                role="document"
              >
                <div className="modal-content">
                  <a
                    href="#"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                  <div className="modal-header">
                    <h5 className="modal-title">Attached Groups</h5>
                  </div>
                  <div className="modal-body">
                    {Array.isArray(this.state.attach_group) &&
                    this.state.attach_group.length > 0 ? (
                      <div className="d-flex flex-wrap" style={{ gap: "10px" }}>
                        {this.state.attach_group.map((group, index) => (
                          <div
                            key={index}
                            className="d-flex align-items-center shadow-sm"
                            style={{
                              backgroundColor: "#f1f5f9",
                              padding: "6px 14px",
                              fontSize: "14px",
                              color: "#1e293b",
                              fontWeight: 500,
                            }}
                          >
                            <em
                              className="icon ni ni-dot-fill"
                              style={{
                                color: "#5b93ff",
                                marginRight: "6px",
                                fontSize: "12px",
                              }}
                            ></em>
                            {group.group_title}
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p className="text-dark">No Groups Attached</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* Modal Group Desc */}
            {/* MODAL DEFAULT GROUP START */}
            <div className="modal fade" tabIndex="-1" id="modalDefaultAlert">
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <a
                    style={{ cursor: "pointer" }}
                    className="close"
                    onClick={() => {
                      this.modalHideDefault();
                    }}
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                  <div className="modal-body modal-body-lg text-center">
                    <div className="nk-modal">
                      <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-star-fill bg-success"></em>
                      <h4 className="nk-modal-title">Make Default Group?</h4>
                      {this.state.errorMessageDefault !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h4>Error</h4>
                              <p>{this.state.errorMessageDefault}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {this.state.successMessageDefault !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-success">
                            <div className="alert-text">
                              <h4>Success</h4>
                              <p>{this.state.successMessageDefault}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      <div className="nk-modal-text">
                        <div className="caption-text">
                          Are you sure you want make this group default?
                        </div>
                      </div>
                      <div className="nk-modal-action">
                        <button
                          style={{
                            cursor: "pointer",
                          }}
                          disabled={
                            this.state.disabled || this.state.isProcessing
                          }
                          className="btn btn-lg btn-mw btn-danger"
                          onClick={() => {
                            this.modalHideDefault();
                          }}
                        >
                          CANCEL
                        </button>
                        {"  "}
                        <button
                          style={{
                            cursor: "pointer",
                          }}
                          className="btn btn-lg btn-mw btn-primary"
                          onClick={() => {
                            this.setDefault(this.state.default_id);
                          }}
                          disabled={
                            this.state.disabled || this.state.isProcessing
                          }
                        >
                          <span>MAKE DEFAULT</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* MODAL DEFAULT GROUP END */}
            {/* MODAL UNDEFAULT GROUP START */}
            <div className="modal fade" tabIndex="-1" id="modalDefaultAlertNew">
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <a
                    style={{ cursor: "pointer" }}
                    className="close"
                    onClick={() => {
                      this.modalHideDefaultNew();
                    }}
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                  <div className="modal-body modal-body-lg text-center">
                    <div className="nk-modal">
                      <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-star bg-success"></em>
                      <h4 className="nk-modal-title">
                        Remove as Default Group?
                      </h4>
                      {this.state.errorMessageDefault !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h4>Error</h4>
                              <p>{this.state.errorMessageDefault}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {this.state.successMessageDefault !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-success">
                            <div className="alert-text">
                              <h4>Success</h4>
                              <p>{this.state.successMessageDefault}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      <div className="nk-modal-text">
                        <div className="caption-text">
                          This group will no longer be the default selection for
                          new users. Are you sure you want to continue?
                        </div>
                      </div>
                      <div className="nk-modal-action">
                        <button
                          style={{
                            cursor: "pointer",
                          }}
                          disabled={
                            this.state.disabled || this.state.isProcessing
                          }
                          className="btn btn-lg btn-mw btn-danger"
                          onClick={() => {
                            this.modalHideDefaultNew();
                          }}
                        >
                          CANCEL
                        </button>
                        {"  "}
                        <button
                          style={{
                            cursor: "pointer",
                          }}
                          className="btn btn-lg btn-mw btn-primary"
                          onClick={() => {
                            this.unsetDefault(this.state.default_id);
                          }}
                          disabled={
                            this.state.disabled || this.state.isProcessing
                          }
                        >
                          <span>REMOVE DEFAULT</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* MODAL UNDEFAULT GROUP END */}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
    userRoleItems: state.userRoleItems,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ClientRoles);
